import { Alert } from '@bees-web/hexa-ui'
import { FC } from 'react'

import { useLoginErrorNotification } from '../hooks/useLoginErrorNotification'

const GUEST_HOMEPAGE_KEY = 'GUEST_HOMEPAGE'

const LoginErrorNotification: FC<{ pageKey: string }> = ({ pageKey }) => {
  const isGuestHomepage = pageKey === GUEST_HOMEPAGE_KEY

  const { isShowing, message, handleClose } = useLoginErrorNotification()

  if (!message || !isGuestHomepage || !isShowing) return null

  return (
    <Alert
      isOpen={isShowing}
      variant='toast'
      type='error'
      dismissable
      time='default'
      onClose={handleClose}
      role='alert'
    >
      {message}
    </Alert>
  )
}

export default LoginErrorNotification
